import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { contractApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const contracts = fetcher.extend(() => ({ prefixUrl: `${API.CONTRACTS}` }));

export const fetchContract = async (key: string, { signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await contracts.get(key, { signal }).json(contractApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
